"use client";

import { useState } from "react";
import DateValueInput from "@/components/resumeEditor/DateValueInput";
import { formatDateRange } from "@/lib/resumeEditor/date";
import type { DateValue } from "@/lib/resumeEditor/types";

export default function InlineDateEditor({
  className,
  start,
  end,
  current,
  onChangeStart,
  onChangeEnd,
  onChangeCurrent,
  singleDate = false,
}: {
  className?: string;
  start?: DateValue;
  end?: DateValue;
  current?: boolean;
  onChangeStart?: (value: DateValue) => void;
  onChangeEnd?: (value: DateValue) => void;
  onChangeCurrent?: (current: boolean) => void;
  singleDate?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const label = singleDate ? formatDateRange(start, undefined) : formatDateRange(start, end, current);

  return (
    <span className="relative inline-block" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`${className ?? ""} rounded px-1 hover:bg-violet-50 dark:hover:bg-violet-500/10`}
      >
        {label || "Add date"}
      </button>
      {open ? (
        <div className="absolute right-0 top-full z-30 mt-1 w-max rounded-xl border border-slate-200 bg-white p-3 shadow-xl dark:border-slate-700 dark:bg-[#0f172a]">
          <div className="space-y-2">
            {singleDate ? (
              <DateValueInput value={start} onChange={(v) => onChangeStart?.(v)} />
            ) : (
              <>
                <DateValueInput value={start} onChange={(v) => onChangeStart?.(v)} />
                <DateValueInput
                  value={end}
                  onChange={(v) => onChangeEnd?.(v)}
                  current={current}
                  onCurrentChange={onChangeCurrent}
                />
              </>
            )}
          </div>
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="mt-2 w-full rounded-lg bg-violet-600 py-1 text-xs font-semibold text-white hover:bg-violet-700"
          >
            Done
          </button>
        </div>
      ) : null}
    </span>
  );
}
